import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { useTranslation } from 'react-i18next';
import { Section } from '@/shared/ui/layout/Section';
import type { ApiDashboardMonthlyStat } from '@/shared/types/api/dashboard';

type Props = { data: ApiDashboardMonthlyStat[] };

export const FeaturesDashboardMonthlyParcelsChart = ({ data }: Props) => {
  const { t } = useTranslation();
  return (
    <Section title={t('dashboard.chart.monthlyTitle')} description={t('dashboard.chart.monthlySubtitle')}>
      <div className="h-72 w-full">
        <ResponsiveContainer>
          <BarChart data={data} margin={{ top: 4, right: 12, left: -12, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
            <XAxis dataKey="month" stroke="#94a3b8" tick={{ fontSize: 12 }} />
            <YAxis stroke="#94a3b8" tick={{ fontSize: 12 }} allowDecimals={false} />
            <Tooltip
              contentStyle={{
                borderRadius: 12,
                border: '1px solid #e2e8f0',
                boxShadow: '0 6px 24px -8px rgba(15,23,42,0.16)',
              }}
              cursor={{ fill: 'rgba(37,99,235,0.06)' }}
            />
            <Bar dataKey="count" radius={[8, 8, 0, 0]} fill="#2563eb" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Section>
  );
};
